// extracted by mini-css-extract-plugin
export default {"selectRoot":"Select_selectRoot__l0kkO","fullWidth":"Select_fullWidth__CDGZG","label":"Select_label__B44vK","input":"Select_input__yAbFO","errorText":"Select_errorText__f7dW5"};